---
de:
  market_outlook:
    duration: Jahresdauerlinie
    forward_contracts: Forward Verträge
    futures_prices_ytd: Future-Preise YTD
    heading: Marktaussichten
    high: P95
    info_text: Die Excel-Datei enthält alle Preisbereiche, nicht nur die ausgewählten.
    lowerq: Untere Quartile
    median: Median
    minimum: P5
    nasim: Preise für die Preiszone können derzeit nicht simuliert werden
    pfc: Preis-Forward-Kurve
    pfc_table: Preis-Forward-tabelle
    simulations: Preissimulationen
    spot_prices_ytd: Strompreise YTD
    upperq: Obere Quartile
